import PropTypes from 'prop-types';

const AcademyModuleResourceType = PropTypes.shape({
  category: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.number,
});

export default AcademyModuleResourceType;
